<div class="async-notification-header" layout layout-align-items-center>
  @if (job.candidates) {
    <rt-candidates-avatars [candidates]="job.candidates" margin-right-small></rt-candidates-avatars>
  }
  <rt-async-jobs-progress-display [title]="job.title" [message]="job.message" [job]="job">
  </rt-async-jobs-progress-display>
</div>
<div class="controls">
  @if (job.done && job.errors.length > 0) {
    <div class="errors">
      <rt-icon
        [colorToken]="'colorIconCriticalDefault'"
        [name]="job.errors.length >= job.total ? 'error' : 'warning'"
        margin-right-small-xx
      ></rt-icon>
      <span>{{ 'app.background_job_progress.show_errors' | translate }}</span>
    </div>
  }

  @if (job.done && (actionButtonLabel || job.actionButtonLabel)) {
    <rt-button (click)="actionButtonClick.emit()" size="small" variant="plain-ghost">
      {{ actionButtonLabel || job.actionButtonLabel }}
    </rt-button>
  }
  <rt-button (click)="closeNotification.emit(job.uuid)" size="small" variant="plain-ghost">
    {{ 'app.automated_actions.assistant.close' | translate }}
  </rt-button>
</div>
